import { JernbanekryssningMedFare } from "../../../services/RuteplanAPI";
import dangerIconResource from "../../../assets/danger.svg"
import L from "leaflet";
import { Marker } from "react-leaflet";
import { useRouteFeatureDialogStoreActions } from "../../../stores/RouteFeatureDialogStore";


const dangerIcon = L.icon({
    iconUrl: dangerIconResource,
    iconRetinaUrl: dangerIconResource,
    iconAnchor: [14, 28],
    iconSize: [28, 28]
  });


export interface IJernbarekryssMedFareProps {
    jernbanekryss: Array<JernbanekryssningMedFare>
}

export default function JernbanekryssMedFareMarkers(props: IJernbarekryssMedFareProps) {
    const { setClickedRoadFeature, setRoadFeatureDialogIsOpen } = useRouteFeatureDialogStoreActions();
    const { jernbanekryss } = props;

    return (
        <>
            {jernbanekryss && jernbanekryss.map( (jernbane: JernbanekryssningMedFare, index: number) => {
                return (
                    <Marker 
                        key={jernbane.nvdbId + index}
                        position={[jernbane.location!.y, jernbane.location!.x]}
                        icon = {dangerIcon}
                        eventHandlers={
                            {
                                click: () => {
                                    setClickedRoadFeature(jernbane);
                                    setRoadFeatureDialogIsOpen(true);
                                }
                            }
                        }
                    />
                )
            })}

        </>
    );
    

}